if (!customElements.get("clear-size-range")) {
  customElements.define(
    "clear-size-range",
    class ClearSizeRange extends HTMLElement {
      constructor() {
        super();

        this.config = JSON.parse(
          this.querySelector("[data-config]").textContent
        );

        this.link = this.querySelector("a");

        this.link.href = this.getHref();
      }

      getHref() {
        const url = new URL(window.location);

        url.searchParams.delete(this.config.paramName);

        return url.toString();
      }
    }
  );
}
